import React, { useEffect, useState } from 'react';
import { getBuyLicenseList } from "../services/tenant-identity-service";
import { Link } from 'react-router-dom';
import { getCountry } from '../services/country-service';
import { getLanguageGuid } from '../services/language-service';
import '../styles/loader.scss';
import Loader from '../images/transparent-loader.png';
import DataGrid, {
    Column, Pager,
    Paging,
    SearchPanel, Export,
    FilterRow
} from 'devextreme-react/data-grid';

let SearchParam = require('wherecomposer/dist/SearchParam').SearchParam;
let SearchOperationBuilder = require('wherecomposer/dist/SearchParam').SearchOperationBuilder;
let ConditionCreator = require('wherecomposer/dist/ConditionCreator').ConditionCreator;


function BuyLicense(props) {

    const [buyLicenseList, setBuyLicenseList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const pageSizes = [10, 25, 50, 100];

    useEffect(() => {
        getBuyLicense();

        return () => {
        };

    }, []);

    const getBuyLicense = async () => {
        try {
            setLoading(true);
            let countryList = await getCountries();
            console.log('getBuyLicense countryList', countryList);
            let response = await getBuyLicenseList();

            await response.forEach((obj) => {
                if (obj.hasOwnProperty('countryGuid')) {
                    let selectedData = countryList.filter((countryObj) => {
                        return countryObj.GroupGuid.toLowerCase() === obj.countryGuid.toLowerCase()
                    });

                    if (selectedData.length > 0) {
                        Object.assign(obj, { 'Country': selectedData[0] });
                    } else {
                        Object.assign(obj, { 'Country': { Name: '' } });
                    }
                } else {
                    Object.assign(obj, { 'Country': { Name: '' } })
                }

                if (obj.hasOwnProperty('userPoolStatus')) {
                    if (obj.userPoolStatus === "CONFIRMED") {
                        Object.assign(obj, { 'IsOtpVerified': 'Verified' });
                    } else {
                        Object.assign(obj, { 'IsOtpVerified': 'Not Verified' });
                    }
                }
            });

            setBuyLicenseList(response);
            setLoading(false);
        } catch (error) {
            console.log('getBuyLicense error', error);
            setLoading(false);
        }

    }

    const getCountryData = (objWhere) => {
        return new Promise((resolve, reject) => {
            getCountry(objWhere).then(data => {
                resolve(data);
            }).catch((error) => {
                console.log('getCountryData err.......', error)
                reject(error);
            });
        });
    }

    const getCountries = async () => {
        try {
            let searchParamArray = [];

            let languageGuid = await getLanguageGuid('en');
            let objSearchParam2 = new SearchParam();
            objSearchParam2.searchParamCreate("LanguageGuid", "Guid", languageGuid, SearchOperationBuilder.create(true, false, false), false);
            searchParamArray.push(objSearchParam2);
            let objCreator = new ConditionCreator();
            let result = objCreator.getSearchCondition(searchParamArray);
            let objWhere = result.toJsonString();

            let response = await getCountryData(objWhere);
            let countryList = response.data.getCountries
            return countryList;
        } catch (error) {
            console.log('Error');
        }

    }

    const calculateSerialNo = (cellInfo) => {
        return cellInfo.rowIndex + 1;
    }

    return (
        <div className="App">
            <div className="logout_btn">
                <Link to='/ServiceList'>
                    <div className="login_submit_button text-center">Back</div>{' '}
                </Link>
            </div>
            <DataGrid
                dataSource={buyLicenseList}
                keyExpr="tenantUserGuid"
                focusedRowEnabled={true}
                allowColumnResizing={true}
                wordWrapEnabled={true}
                allowColumnReordering={true}
                showBorders={true}>
                <FilterRow visible={true} />
                <Paging enabled={false} />
                <Export enabled={true} />
                <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                <Paging defaultPageSize={50} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Column
                    caption="SI NO"
                    cellRender={calculateSerialNo}
                />
                <Column
                    dataField="tenantUserName"
                    caption="Name"
                />
                <Column
                    dataField="companyName"
                    caption="Company Name"
                />
                <Column
                    dataField="email"
                    caption="Email"
                />
                <Column
                    dataField="mobileNo"
                    caption="Mobile No"
                />
                <Column
                    dataField="Country.Name"
                    caption="Country"
                />
                <Column
                    dataField="userStatus"
                    caption="Status"
                />
                <Column
                    dataField="IsOtpVerified"
                    caption="Is OTP Verified"
                />
                <Column
                    dataField="enabled"
                    caption="Enabled"
                />
                <Column
                    dataField="createdDate"
                    caption="Created Date"
                    dataType="datetime"
                />
                <Column
                    dataField="lastModifiedDate"
                    caption="Last Modified Date"
                    dataType="datetime"
                />
            </DataGrid>

            {
                isLoading ? (
                    <img src={Loader} alt="" className="loader" />
                ) : null
            }
        </div>
    )
}

export default BuyLicense
